import { useState } from "react";
import { Agent } from "../sharedTypes";
import { secureGet } from "../utils/secureStorage";

export const useCurrentUser = () => {
  const [user] = useState<Agent | null>(() => {
    const storedUser = secureGet(localStorage, "userData");
    if (storedUser) {
      try {
        return JSON.parse(storedUser);
      } catch (error) {
        console.error("Failed to parse user data from localStorage", error);
        return null;
      }
    }
    return null;
  });

  return user;
};
